// eslint-disable-next-line import/prefer-default-export
import { AxiosError } from "axios";

export const variableErrors = {
  org: {
    error: "Error: unknown organisation",
    messageToClient: "Sorry, I can't provide insights unless you're in an organisation.",
  },
  team: {
    error: "Error: unknown team",
    messageToClient: "Sorry, I can't provide insights unless you're in a team.",
  },
  subject: {
    error: "Error: (unknown subject user)",
    messageToClient: "Sorry, I don't know who the subject is.",
  },
  user: {
    error: "Error: (anonymous / not-logged-in user)",
    messageToClient: "Sorry, I can't provide insights unless you're logged in.",
  },
  unknown: {
    error: "Error: unknown error occurred",
    messageToClient: "An error occurred. Please try again later.",
  },
};

export type VariableError = keyof typeof variableErrors;

export function renderErrorMessageToClient(messages: string[]): string {
  const message = messages.find((m) => m.includes("Error:")) ?? messages[0];

  if (message.includes("unknown variable")) {
    return "Sorry, there was an error providing a response.";
  }

  // either return an error from processPromptVars
  const errorKey = Object.keys(variableErrors).find((key) =>
    message.includes(variableErrors[key as VariableError].error),
  );
  if (errorKey) {
    return variableErrors[errorKey as VariableError].messageToClient;
  }
  // or return an error from the server
  return message.replace("Error: ", "");
}

export function handleApiError(e: unknown): string {
  if (e instanceof Error) {
    const error = e as AxiosError;
    return `Error: ${error.response?.data}`;
  }
  return "Error: Unknown error occurred";
}
